import Loader from "../../../../utils/loader/Loader";

function TeacherIdPopup({
  visible,
  onClose,
  setTeacherId,
  onSubmit,
  loading,
  getTranslateText,
}) {
  if (!visible) return null;

  const getTextByKey = (key, fallback) => {
    const item = getTranslateText?.data?.find((item) => item.pageKey === key);
    return item?.keyValue || fallback;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      {loading ? (
        <>
          <div className="flex justify-center items-center h-[80%]">
            <Loader type="spinningBubbles" color="#2e376c" />
          </div>
        </>
      ) : (
        <>
          <div className="bg-white rounded-2xl shadow-lg w-[350px] p-6 relative">
            <h2 className="text-md font-semibold mb-4 text-left">
              {getTextByKey("teacher_id", "Teacher ID")}
            </h2>

            <div className="relative">
              <input
                id="teacherIdInput"
                placeholder={getTextByKey("key_type_here", "Type here")}
                a
                minLength={6}
                maxLength={8}
                onChange={(e) => {
                  setTeacherId(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
                className="w-full border rounded-lg px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="flex justify-between mt-6 gap-2">
              <button
                onClick={onClose}
                className="bg-white text-[#003CB3] px-6 py-2 rounded-md w-[50%]"
              >
                {getTextByKey("label_cancel", "Cancel")}
              </button>
              <button
                type="button"
                onClick={() => {
                  onSubmit();
                  setTeacherId(null);
                }}
                className="bg-[#101942] text-white px-6 py-2 rounded-md w-[50%]"
              >
                {getTextByKey("cont_text", "Continue")}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default TeacherIdPopup;
